import { render, staticRenderFns } from "./StudentBulkCreate.vue?vue&type=template&id=670cee60&"
import script from "./StudentBulkCreate.vue?vue&type=script&lang=ts&"
export * from "./StudentBulkCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports